// src/pages/NricAudit.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Renew.css";                      // reuse Renew styling
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";

const NricAudit = () => {
  useEscapeToGoBack();
  const navigate = useNavigate();
  const startRef = useRef(null);

  const [start, setStart] = useState("");  // yyyy-mm-dd
  const [end, setEnd]     = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    requestAnimationFrame(() => startRef.current?.focus());
  }, []);

  const generate = async () => {
    setErr("");
    if (!start || !end) { setErr("Please select both dates."); return; }
    if (new Date(start) > new Date(end)) { setErr("Start must be before or the same as End."); return; }

    setLoading(true);
    try {
      const res = await axios.get(
        "https://www.lianfoong.com/api/pawn-transactions/reports/nric-audit.pdf",
        {
          params: { start, end },           // LocalDate strings; backend treats end inclusively
          responseType: "blob",
          headers: { Accept: "application/pdf" },
        }
      );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener,noreferrer");       // open in new tab
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) {
      console.error(e);
      setErr("Failed to generate report.");
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") { e.preventDefault(); generate(); }
  };

  return (
    <div className="renew-container">
      <h2 className="title">NRIC/FIN Audit Report</h2>

      <div className="form-group">
        <label>Start Date:</label>
        <input
          ref={startRef}
          type="date"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </div>

      <div className="form-group">
        <label>End Date:</label>
        <input
          type="date"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </div>

      {err && <p className="error-message">{err}</p>}

      <button className="next-btn" onClick={generate} disabled={loading}>
        {loading ? "Generating…" : "Generate PDF"}
      </button>

      <button className="search-btn" onClick={() => navigate("/other")}>
        Back
      </button>
    </div>
  );
};

export default NricAudit;
